import React, { useState, useRef, useEffect } from 'react';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from '../exportUtils';

/* ─── Static sample data ───────────────────────────────────── */
const SAMPLE_DATA = {
  Sell: [
    { id: 1,  invoiceNo: 'INV-001', date: '2025-01-24', customer: 'Walk-In Customer', contact: '-',          location: "Lefty's Liquor", paymentStatus: 'Paid',    paymentMethod: 'Cash', totalAmount: 150.00, totalPaid: 150.00, addedBy: 'Admin' },
    { id: 2,  invoiceNo: 'INV-002', date: '2025-01-23', customer: 'John Doe',         contact: '9876543210', location: "Lefty's Liquor", paymentStatus: 'Due',     paymentMethod: 'Card', totalAmount: 45.50,  totalPaid: 0.00,   addedBy: 'Staff' },
    { id: 3,  invoiceNo: 'INV-003', date: '2025-01-23', customer: 'Jane Smith',       contact: '8765432190', location: "Lefty's Liquor", paymentStatus: 'Partial', paymentMethod: 'Cash', totalAmount: 200.00, totalPaid: 100.00, addedBy: 'Admin' },
    { id: 4,  invoiceNo: 'INV-004', date: '2025-01-22', customer: 'Walk-In Customer', contact: '-',          location: "Lefty's Liquor", paymentStatus: 'Paid',    paymentMethod: 'Cash', totalAmount: 12.99,  totalPaid: 12.99,  addedBy: 'Staff' },
    { id: 5,  invoiceNo: 'INV-005', date: '2025-01-22', customer: 'Bob Williams',     contact: '7654321980', location: "Lefty's Liquor", paymentStatus: 'Paid',    paymentMethod: 'Card', totalAmount: 89.00,  totalPaid: 89.00,  addedBy: 'Admin' },
    { id: 6,  invoiceNo: 'INV-1042',date: '2026-02-19', customer: 'Shahabaj',         contact: '7620629466', location: "Lefty's Liquor", paymentStatus: 'Paid',    paymentMethod: 'Cash', totalAmount: 12.15,  totalPaid: 12.15,  addedBy: 'Admin' },
    { id: 7,  invoiceNo: 'INV-1046',date: '2026-02-18', customer: 'John Doe',         contact: '9876543210', location: "Lefty's Liquor", paymentStatus: 'Due',     paymentMethod: 'Card', totalAmount: 45.00,  totalPaid: 20.00,  addedBy: 'Staff' },
    { id: 8,  invoiceNo: 'INV-1047',date: '2026-02-17', customer: 'Alice Martin',     contact: '6543219870', location: "Lefty's Liquor", paymentStatus: 'Paid',    paymentMethod: 'Bank', totalAmount: 305.00, totalPaid: 305.00, addedBy: 'Admin' },
    { id: 9,  invoiceNo: 'INV-1048',date: '2026-02-16', customer: 'Carlos Rivera',    contact: '5432198760', location: "Lefty's Liquor", paymentStatus: 'Partial', paymentMethod: 'Cash', totalAmount: 78.50,  totalPaid: 50.00,  addedBy: 'Staff' },
    { id: 10, invoiceNo: 'INV-1049',date: '2026-02-15', customer: 'Sara Connor',      contact: '4321987650', location: "Lefty's Liquor", paymentStatus: 'Paid',    paymentMethod: 'Card', totalAmount: 220.00, totalPaid: 220.00, addedBy: 'Admin' },
  ],
  'Sales Payments': [
    { id: 1, invoiceNo: 'SP-001', date: '2026-02-19', customer: 'Shahabaj',   contact: '7620629466', location: "Lefty's Liquor", paymentStatus: 'Paid', paymentMethod: 'Cash', totalAmount: 12.15,  totalPaid: 12.15,  addedBy: 'Admin' },
    { id: 2, invoiceNo: 'SP-002', date: '2026-02-18', customer: 'John Doe',   contact: '9876543210', location: "Lefty's Liquor", paymentStatus: 'Paid', paymentMethod: 'Card', totalAmount: 45.00,  totalPaid: 45.00,  addedBy: 'Staff' },
    { id: 3, invoiceNo: 'SP-003', date: '2026-02-17', customer: 'Alice Martin',contact: '6543219870', location: "Lefty's Liquor", paymentStatus: 'Paid', paymentMethod: 'Bank', totalAmount: 305.00, totalPaid: 305.00, addedBy: 'Admin' },
  ],
  Purchases: [
    { id: 1, invoiceNo: 'PO-101', date: '2026-02-17', customer: 'Supplier A', contact: '1112223333', location: "Lefty's Liquor", paymentStatus: 'Paid', paymentMethod: 'Bank', totalAmount: 320.00, totalPaid: 320.00, addedBy: 'Admin' },
    { id: 2, invoiceNo: 'PO-102', date: '2026-02-16', customer: 'Supplier B', contact: '4445556666', location: "Lefty's Liquor", paymentStatus: 'Due',  paymentMethod: 'Cash', totalAmount: 150.00, totalPaid: 0.00,   addedBy: 'Staff' },
    { id: 3, invoiceNo: 'PO-103', date: '2026-02-15', customer: 'Supplier C', contact: '7778889999', location: "Lefty's Liquor", paymentStatus: 'Paid', paymentMethod: 'Card', totalAmount: 780.00, totalPaid: 780.00, addedBy: 'Admin' },
  ],
  'Purchase Payments': [
    { id: 1, invoiceNo: 'PP-001', date: '2026-02-17', customer: 'Supplier A', contact: '1112223333', location: "Lefty's Liquor", paymentStatus: 'Paid', paymentMethod: 'Bank', totalAmount: 320.00, totalPaid: 320.00, addedBy: 'Admin' },
    { id: 2, invoiceNo: 'PP-002', date: '2026-02-15', customer: 'Supplier C', contact: '7778889999', location: "Lefty's Liquor", paymentStatus: 'Paid', paymentMethod: 'Card', totalAmount: 780.00, totalPaid: 780.00, addedBy: 'Staff' },
  ],
  Expenses: [
    { id: 1, invoiceNo: 'EXP-001', date: '2026-02-15', customer: 'Staff',    contact: '-', location: "Lefty's Liquor", paymentStatus: 'Paid', paymentMethod: 'Cash', totalAmount: 1500.00, totalPaid: 1500.00, addedBy: 'Admin' },
    { id: 2, invoiceNo: 'EXP-002', date: '2026-02-14', customer: 'Landlord', contact: '-', location: "Lefty's Liquor", paymentStatus: 'Paid', paymentMethod: 'Bank', totalAmount: 6000.00, totalPaid: 6000.00, addedBy: 'Admin' },
    { id: 3, invoiceNo: 'EXP-003', date: '2026-02-12', customer: 'Utilities',contact: '-', location: "Lefty's Liquor", paymentStatus: 'Paid', paymentMethod: 'Bank', totalAmount: 450.00,  totalPaid: 450.00,  addedBy: 'Staff' },
  ],
};

const SECTION_TABS = ['Sell', 'Sales Payments', 'Purchases', 'Purchase Payments', 'Expenses'];

/* ─── Status Badge ─────────────────────────────────────────── */
const StatusBadge = ({ status }) => {
  const styles = {
    Paid:    { background: '#dcfce7', color: '#166534' },
    Due:     { background: '#fee2e2', color: '#991b1b' },
    Partial: { background: '#fef9c3', color: '#854d0e' },
    Overdue: { background: '#ffe4e6', color: '#9f1239' },
  };
  const s = styles[status] || { background: '#f1f5f9', color: '#475569' };
  return (
    <span style={{ ...s, padding: '0.25rem 0.65rem', borderRadius: '999px', fontSize: '0.75rem', fontWeight: 700, whiteSpace: 'nowrap' }}>
      {status}
    </span>
  );
};

/* ─── Main Component ───────────────────────────────────────── */
const Transactions = () => {
  const [activeSection, setActiveSection]   = useState('Sell');
  const [search, setSearch]                 = useState('');
  const [entries, setEntries]               = useState(25);
  const [showExport, setShowExport]         = useState(false);
  const [showFilter, setShowFilter]         = useState(false);
  const [filterStatus, setFilterStatus]     = useState('All');
  const [filterMethod, setFilterMethod]     = useState('All');
  const [openActionId, setOpenActionId]     = useState(null);
  const [viewItem, setViewItem]             = useState(null);
  const exportRef  = useRef(null);
  const actionRefs = useRef({});

  /* Close export dropdown on outside click */
  useEffect(() => {
    const handler = (e) => {
      if (exportRef.current && !exportRef.current.contains(e.target)) setShowExport(false);
      if (!Object.values(actionRefs.current).some(r => r && r.contains(e.target))) setOpenActionId(null);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  /* Filtered data */
  const data = SAMPLE_DATA[activeSection] || [];
  const filtered = data.filter(r => {
    const term = search.toLowerCase();
    const matchSearch = (r.customer || '').toLowerCase().includes(term) ||
                        (r.invoiceNo || '').toLowerCase().includes(term) ||
                        (r.contact || '').includes(term);
    const matchStatus = filterStatus === 'All' || r.paymentStatus === filterStatus;
    const matchMethod = filterMethod === 'All' || r.paymentMethod === filterMethod;
    return matchSearch && matchStatus && matchMethod;
  }).slice(0, entries);

  /* Export handler */
  const handleExport = (format) => {
    if (!filtered.length) { alert('No data to export'); setShowExport(false); return; }
    const headers = ['Invoice No.', 'Date', 'Customer', 'Contact Number', 'Location', 'Payment Status', 'Payment Method', 'Total Amount', 'Total Paid', 'Added By'];
    const rows = filtered.map(r => [r.invoiceNo, r.date, r.customer, r.contact, r.location, r.paymentStatus, r.paymentMethod, r.totalAmount?.toFixed(2), r.totalPaid?.toFixed(2), r.addedBy || '—']);
    const title    = `Transactions — ${activeSection}`;
    const filename = `transactions_${activeSection.toLowerCase().replace(/ /g, '_')}`;
    if (format === 'CSV')   exportToCSV(headers, rows, filename);
    if (format === 'Excel') exportToExcel(headers, rows, filename);
    if (format === 'PDF')   exportToPDF(title, headers, rows, filename);
    if (format === 'Print') printPage();
    setShowExport(false);
  };

  const resetFilters = () => { setFilterStatus('All'); setFilterMethod('All'); };

  return (
    <div className="accounting-page">

      {/* ── Card wrapper ── */}
      <div className="main-card" style={{ padding: 0, overflow: 'visible' }}>

        {/* ── Section Tabs ── */}
        <div className="product-tabs" style={{ margin: 0, borderBottom: '1px solid var(--etpos-border,#e2e8f0)', overflowX: 'auto', flexWrap: 'nowrap' }}>
          {SECTION_TABS.map(tab => (
            <div
              key={tab}
              className={`product-tab${activeSection === tab ? ' active' : ''}`}
              onClick={() => { setActiveSection(tab); setSearch(''); setFilterStatus('All'); setFilterMethod('All'); }}
              style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
            >
              {tab}
            </div>
          ))}
        </div>

        {/* ── Toolbar ── */}
        <div className="table-controls" style={{ padding: '0.75rem 1rem', borderBottom: '1px solid var(--etpos-border,#e2e8f0)', flexWrap: 'wrap', gap: '0.5rem' }}>
          {/* Left: entries */}
          <div className="table-controls-left" style={{ gap: '0.5rem' }}>
            <span style={{ fontSize: '0.85rem', color: 'var(--etpos-text-muted,#64748b)' }}>Show</span>
            <select
              value={entries}
              onChange={e => setEntries(Number(e.target.value))}
              style={{ height: '38px', padding: '0 0.5rem', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '0.875rem' }}
            >
              {[10, 25, 50, 100].map(n => <option key={n}>{n}</option>)}
            </select>
            <span style={{ fontSize: '0.85rem', color: 'var(--etpos-text-muted,#64748b)' }}>entries</span>
          </div>

          {/* Right: search + filter + export */}
          <div className="table-controls-right" style={{ gap: '0.5rem', flexWrap: 'wrap' }}>
            {/* Search */}
            <div style={{ position: 'relative' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              <input
                placeholder="Search..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{ height: '38px', paddingLeft: '2.2rem', paddingRight: '0.75rem', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '0.875rem', outline: 'none', minWidth: '200px' }}
              />
            </div>

            {/* Filter button */}
            <button
              onClick={() => setShowFilter(true)}
              style={{ height: '38px', padding: '0 1rem', background: 'var(--etpos-primary,#2563eb)', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '0.875rem', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/></svg>
              Filters
            </button>

            {/* Export dropdown */}
            <div ref={exportRef} style={{ position: 'relative' }}>
              <button
                onClick={() => setShowExport(p => !p)}
                style={{ height: '38px', padding: '0 1rem', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '0.875rem', fontWeight: 600, color: '#475569', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
                Export ▾
              </button>
              {showExport && (
                <div style={{ position: 'absolute', right: 0, top: '110%', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 50, minWidth: '160px' }}>
                  {['CSV','Excel','PDF','Print'].map(f => (
                    <div key={f} onClick={() => handleExport(f)}
                      style={{ padding: '0.6rem 1rem', cursor: 'pointer', fontSize: '0.875rem', color: '#334155', borderBottom: f !== 'Print' ? '1px solid #f1f5f9' : 'none' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    >
                      Export {f}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── Active filter badges ── */}
        {(filterStatus !== 'All' || filterMethod !== 'All') && (
          <div style={{ padding: '0.5rem 1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap', borderBottom: '1px solid var(--etpos-border,#e2e8f0)', background: '#f8fafc' }}>
            <span style={{ fontSize: '0.8rem', color: '#64748b', alignSelf: 'center' }}>Filters:</span>
            {filterStatus !== 'All' && (
              <span style={{ background: '#dbeafe', color: '#1d4ed8', padding: '0.2rem 0.6rem', borderRadius: '999px', fontSize: '0.78rem', fontWeight: 600 }}>
                Status: {filterStatus} <span style={{ cursor: 'pointer', marginLeft: '4px' }} onClick={() => setFilterStatus('All')}>✕</span>
              </span>
            )}
            {filterMethod !== 'All' && (
              <span style={{ background: '#dbeafe', color: '#1d4ed8', padding: '0.2rem 0.6rem', borderRadius: '999px', fontSize: '0.78rem', fontWeight: 600 }}>
                Method: {filterMethod} <span style={{ cursor: 'pointer', marginLeft: '4px' }} onClick={() => setFilterMethod('All')}>✕</span>
              </span>
            )}
            <button onClick={resetFilters} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600 }}>Clear All</button>
          </div>
        )}

        {/* ── Table ── */}
        <div style={{ overflowX: 'auto' }}>
          <table className="products-table" style={{ minWidth: '900px' }}>
            <thead>
              <tr>
                <th style={{ width: '120px' }}>Action</th>
                <th>Date</th>
                <th>Invoice No.</th>
                <th>Customer Name</th>
                <th>Contact Number</th>
                <th>Location</th>
                <th>Payment Status</th>
                <th>Payment Method</th>
                <th style={{ textAlign: 'right' }}>Total Amount</th>
                <th style={{ textAlign: 'right' }}>Total Paid</th>
                <th>Added By</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.id}>
                  <td>
                    <div
                      ref={el => actionRefs.current[r.id] = el}
                      style={{ position: 'relative', display: 'inline-block' }}
                    >
                      <button
                        onClick={() => setOpenActionId(openActionId === r.id ? null : r.id)}
                        style={{ padding: '0.3rem 0.8rem', background: 'var(--etpos-primary,#2563eb)', color: '#fff', border: 'none', borderRadius: '5px', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.3rem' }}
                      >
                        Actions <span>▾</span>
                      </button>
                      {openActionId === r.id && (
                        <div style={{ position: 'absolute', left: 0, top: '110%', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 100, minWidth: '140px' }}>
                          <div
                            onClick={() => { setViewItem(r); setOpenActionId(null); }}
                            style={{ padding: '0.55rem 1rem', cursor: 'pointer', fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.5rem', borderBottom: '1px solid #f1f5f9' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                          >
                            👁 View
                          </div>
                          <div
                            onClick={() => { alert(`Map transaction for ${r.invoiceNo}`); setOpenActionId(null); }}
                            style={{ padding: '0.55rem 1rem', cursor: 'pointer', fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                          >
                            🔗 Map Transaction
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>{r.date}</td>
                  <td><span style={{ fontWeight: 700, color: 'var(--etpos-primary,#2563eb)' }}>{r.invoiceNo}</span></td>
                  <td style={{ fontWeight: 500 }}>{r.customer}</td>
                  <td style={{ fontSize: '0.85rem', color: '#64748b' }}>{r.contact}</td>
                  <td style={{ fontSize: '0.85rem' }}>{r.location}</td>
                  <td><StatusBadge status={r.paymentStatus} /></td>
                  <td style={{ fontSize: '0.85rem' }}>{r.paymentMethod}</td>
                  <td style={{ textAlign: 'right', fontWeight: 600 }}>$ {r.totalAmount.toFixed(2)}</td>
                  <td style={{ textAlign: 'right', fontWeight: 600, color: r.totalPaid >= r.totalAmount ? '#10b981' : '#f59e0b' }}>$ {r.totalPaid.toFixed(2)}</td>
                  <td style={{ fontSize: '0.85rem', color: '#475569' }}>{r.addedBy || '—'}</td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={11} style={{ textAlign: 'center', padding: '3rem', color: '#94a3b8' }}>
                    <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>💳</div>
                    <div style={{ fontWeight: 600 }}>No transactions found</div>
                    <div style={{ fontSize: '0.85rem', marginTop: '0.25rem' }}>Try adjusting your search or filters</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* ── Pagination footer ── */}
        <div style={{ padding: '0.75rem 1rem', fontSize: '0.82rem', color: 'var(--etpos-text-muted,#64748b)', borderTop: '1px solid var(--etpos-border,#e2e8f0)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
          <span>Showing <strong>{filtered.length}</strong> of <strong>{data.length}</strong> entries</span>
          {data.length > entries && (
            <button onClick={() => setEntries(data.length)} style={{ background: 'none', border: '1px solid #e2e8f0', borderRadius: '4px', padding: '0.25rem 0.75rem', cursor: 'pointer', fontSize: '0.8rem', color: '#475569' }}>
              Show All
            </button>
          )}
        </div>
      </div>

      {/* ── Filter Modal ── */}
      {showFilter && (
        <div
          onClick={() => setShowFilter(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(4px)' }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: '12px', width: '95%', maxWidth: '480px', overflow: 'hidden', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}
          >
            <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc' }}>
              <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: 700 }}>Filter Transactions</h3>
              <button onClick={() => setShowFilter(false)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', cursor: 'pointer', color: '#94a3b8', lineHeight: 1 }}>✕</button>
            </div>
            <div style={{ padding: '1.5rem', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.82rem', fontWeight: 700, color: '#475569' }}>Payment Status</label>
                <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}
                  style={{ width: '100%', padding: '0.65rem', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '0.875rem' }}>
                  {['All', 'Paid', 'Due', 'Partial', 'Overdue'].map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.82rem', fontWeight: 700, color: '#475569' }}>Payment Method</label>
                <select value={filterMethod} onChange={e => setFilterMethod(e.target.value)}
                  style={{ width: '100%', padding: '0.65rem', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '0.875rem' }}>
                  {['All', 'Cash', 'Card', 'Bank'].map(m => <option key={m}>{m}</option>)}
                </select>
              </div>
            </div>
            <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'center', gap: '0.75rem', background: '#f8fafc' }}>
              <button onClick={() => { resetFilters(); setShowFilter(false); }}
                style={{ padding: '0.6rem 1.75rem', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem', color: '#475569' }}>
                Reset
              </button>
              <button onClick={() => setShowFilter(false)}
                style={{ padding: '0.6rem 1.75rem', background: 'var(--etpos-primary,#2563eb)', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem' }}>
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── View Transaction Modal ── */}
      {viewItem && (
        <div
          onClick={() => setViewItem(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(4px)' }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: '12px', width: '95%', maxWidth: '520px', overflow: 'hidden', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}
          >
            <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc' }}>
              <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: 700 }}>Transaction Details</h3>
              <button onClick={() => setViewItem(null)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', cursor: 'pointer', color: '#94a3b8', lineHeight: 1 }}>✕</button>
            </div>
            <div style={{ padding: '1.5rem', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem 1.5rem' }}>
              {[
                ['Invoice No.', viewItem.invoiceNo],
                ['Date', viewItem.date],
                ['Customer', viewItem.customer],
                ['Contact', viewItem.contact],
                ['Location', viewItem.location],
                ['Payment Method', viewItem.paymentMethod],
                ['Total Amount', `$ ${viewItem.totalAmount.toFixed(2)}`],
                ['Total Paid', `$ ${viewItem.totalPaid.toFixed(2)}`],
              ].map(([label, value]) => (
                <div key={label}>
                  <div style={{ fontSize: '0.78rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '0.3rem' }}>{label}</div>
                  <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1e293b' }}>{value}</div>
                </div>
              ))}
              <div>
                <div style={{ fontSize: '0.78rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '0.3rem' }}>Payment Status</div>
                <StatusBadge status={viewItem.paymentStatus} />
              </div>
              {viewItem.addedBy && (
                <div>
                  <div style={{ fontSize: '0.78rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '0.3rem' }}>Added By</div>
                  <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1e293b' }}>{viewItem.addedBy}</div>
                </div>
              )}
            </div>
            <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'center', background: '#f8fafc' }}>
              <button onClick={() => setViewItem(null)}
                style={{ padding: '0.6rem 2rem', background: '#334155', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem' }}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Transactions;
